import { useMemo } from 'react';

import { Modal } from '@thefarmersfront/kitchen';

import { ModalContentsContainer, ModalLabelValueRow, ModalSection, Table } from '~/components/common';

import { formatDate } from '~/utils/date';
import { getDeliveryAgencyCollectingShippingLabelsColumnDefs } from '~/utils/delivery-agency/table';

import { DATE_FORMAT } from '~/constants';

import type { CollectingRequestDetail } from '~/types/delivery-agency.types';

import styles from './CollectingRequestDetailModal.module.scss';

const CollectingRequestDetailModal = ({
  open,
  data,
  onClose,
}: {
  open: boolean;
  data: CollectingRequestDetail;
  onClose: () => void;
}) => {
  const { columnDefs } = useMemo(() => getDeliveryAgencyCollectingShippingLabelsColumnDefs(), []);

  return (
    <Modal title="반품 신청 상세" size="xlarge" open={open} onConfirm={onClose}>
      <ModalContentsContainer>
        <ModalSection title="회수 신청 정보">
          <div className={styles['info-container']}>
            <ModalLabelValueRow
              alignItems="start"
              label="반품접수일시"
              value={formatDate(data.collectingRequestedAt, DATE_FORMAT.DATE_TIME) ?? '-'}
            />
            <ModalLabelValueRow alignItems="start" label="반품요청번호" value={data.collectingRequestCode} />
            <ModalLabelValueRow alignItems="start" label="출고번호" value={data.originalOutboundCode} />
            <ModalLabelValueRow
              alignItems="start"
              label="판매처 주문번호(원주문)"
              value={data.clientOrderCodes.join(', ')}
            />
            <ModalLabelValueRow alignItems="start" label="원주문 수령자명" value={data.contact.name} />
            <ModalLabelValueRow alignItems="start" label="고객 연락처" value={data.contact.tel} />
            <ModalLabelValueRow
              alignItems="start"
              label="회수지 도로명 기본주소"
              value={data.collectingSite.primaryAddress}
            />
            <ModalLabelValueRow
              alignItems="start"
              label="상세주소"
              value={data.collectingSite.secondaryAddress || '-'}
            />
            <ModalLabelValueRow
              alignItems="start"
              label="상품회수장소"
              value={data.collectingSite.deliveryLocation?.description ?? '-'}
            />
            <ModalLabelValueRow
              alignItems="start"
              label="상품회수장소 상세"
              value={data.collectingSite.deliveryLocationDetail || '-'}
            />
            <ModalLabelValueRow
              alignItems="start"
              label="출입방법"
              value={data.collectingSite.entranceMethod?.description ?? '-'}
            />
            <ModalLabelValueRow
              alignItems="start"
              label="출입방법 상세"
              value={data.collectingSite.entranceMethodDetail || '-'}
            />
            <ModalLabelValueRow alignItems="start" label="회수할 상품명" value={data.productName} />
            <ModalLabelValueRow alignItems="start" label="회수할 박스 개수" value={String(data.boxCount)} />
            <ModalLabelValueRow
              alignItems="start"
              label="회수한 상품 처리 방식"
              value={data.collectedProductHandling?.description ?? '-'}
            />
            <ModalLabelValueRow
              alignItems="start"
              label="알림톡 즉시 발송"
              value={data.sendAlimTalkImmediately ? 'Y' : 'N'}
            />
          </div>
        </ModalSection>

        <ModalSection title="회수 정보">
          {/* 운송장 건수가 가변이라 고정 높이 대신 행 수에 맞춰 늘어나게 한다 */}
          <Table data={data.collectingShippingLabels} columns={columnDefs} rowStatusType="NO_DATA" autoHeight />
        </ModalSection>
      </ModalContentsContainer>
    </Modal>
  );
};

export default CollectingRequestDetailModal;
